<template>
  <div class="c-step c-step--final">
    <technoLogo />
    
    <Head
      :dataTitle="' '"
      :dataStrong="
        'Tak – din henvendelse er nu sendt til Techno Forsikring, som vil kontakte dig snarest'
      "
    />
  </div>
</template>
<script>
// @ is an alias to /src
import Vue from 'vue';
import Head from '@/components/head/head.vue';
import technoLogo from '@/components/technoLogo/technoLogo.vue';

export default Vue.extend({
  name: 'ThankYou',
  components: {
    Head,
    technoLogo
  },
  mounted() {
    this.$store.dispatch('app/loading', false);
  }
});
</script>
<style lang="scss">
@import '@/assets/scss/components/step.scss';
.c-technoLogo {
  width: 100%;
  .c-technoLogo__logo {
    height: 40px;
    width: 100px;
  }
}
</style>
